import { render, staticRenderFns } from "./TeamRoleList.vue?vue&type=template&id=7225761a&scoped=true&"
import script from "./TeamRoleList.vue?vue&type=script&lang=js&"
export * from "./TeamRoleList.vue?vue&type=script&lang=js&"
import style0 from "./TeamRoleList.vue?vue&type=style&index=0&id=7225761a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7225761a",
  null
  
)

export default component.exports